import React, { useEffect, useState } from "react";
import { Sparkles, Clock, TrendingUp } from "lucide-react";
import { SITE, lastUpdated } from "../mock";
import ResultCard from "./ResultCard";
import { fetchLatest } from "../lib/api";

export default function Hero() {
  const [madhur, setMadhur] = useState(null);
  const [starline, setStarline] = useState(null);

  useEffect(() => {
    fetchLatest("madhur").then(setMadhur).catch(() => {});
    fetchLatest("starline").then(setStarline).catch(() => {});
  }, []);

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-rose-500/10 rounded-full blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(251,191,36,0.06),transparent_50%)]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-12 md:pt-20 md:pb-16">
        <div className="grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-400/10 border border-amber-400/20 text-amber-300 text-xs font-medium tracking-wide">
              <Sparkles className="w-3.5 h-3.5" />
              {SITE.tagline}
            </div>
            <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-slate-100">
              {SITE.name}{" "}
              <span className="bg-gradient-to-r from-amber-300 via-amber-200 to-amber-400 bg-clip-text text-transparent">
                Result Today
              </span>{" "}
              & Chart
            </h1>
            <p className="mt-5 text-slate-400 max-w-xl text-base md:text-lg leading-relaxed">
              {SITE.name} website par aapko daily result updates, chart history aur Starline records ek hi
              jagah par milte hain.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3 text-sm">
              <span className="inline-flex items-center gap-1.5 text-slate-300">
                <Clock className="w-4 h-4 text-amber-300" />
                Last Updated: <span className="text-slate-100">{lastUpdated()}</span>
              </span>
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-emerald-500/10 text-emerald-300 border border-emerald-400/20">
                <TrendingUp className="w-3.5 h-3.5" /> Auto-Refreshed
              </span>
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5">
            <ResultCard
              kind="madhur"
              time={madhur?.time || "--:--"}
              number={madhur?.number || "--"}
            />
            <ResultCard
              kind="starline"
              time={starline?.time || "--:--"}
              number={starline?.number || "--"}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
